$(function () {
    $(".banner-slider .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            fade: true,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: thisElement.closest('.banner-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.banner-slider').find('.sliderNextButton'),
            mobileFirst: true,
            responsive: [{
                breakpoint: 992,
                settings: {
                    slidesToShow: 1
                }
            },]
        });
    })
});


$(function () {
    $(".expertise-list .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            dots: true,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: thisElement.closest('.expertise-list').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.expertise-list').find('.sliderNextButton'),
            mobileFirst: true,
            centerMode: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: "unslick"
                },
                {
                    breakpoint: 992,
                    settings: {
                        dots: true,
                        slidesToShow: 3,
                        centerMode: false,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        dots: true,
                        slidesToShow: 2,
                        centerMode: false,
                        variableWidth: false
                    }
                }
            ]
        });
    })
});

$(function () {
    $(".members-slider .slider-items").each(function () {
        var thisElement = $(this);
        console.log(thisElement);
        var autoplaySpeed = $(this).data('autoplayspeed');
        var autoplayOn = $(this).data('autoplayon');
        thisElement.slick({
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            prevArrow: thisElement.closest('.members-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.members-slider').find('.sliderNextButton'),
            mobileFirst: true,
            centerMode: true,
            variableWidth: false,
            autoplay: autoplayOn,
            autoplaySpeed: autoplaySpeed,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        variableWidth: false
                    }
                },

                {
                    breakpoint: 800,
                    settings: {
                        slidesToShow: 3,
                    }
                },

                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 4,
                    }
                },

                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 5,
                    }
                },

                {
                    breakpoint: 1800,
                    settings: {
                        slidesToShow: 6,
                    }
                }
            ]
        });
    })
});

$(function () {
    $(".team-slider .slider-items").each(function () {
        var thisElement = $(this);
        console.log(thisElement);
        var autoplaySpeed = $(this).data('autoplayspeed');
        var autoplayOn = $(this).data('autoplayon');
        thisElement.slick({
            dots: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            draggable: true,
            prevArrow: thisElement.closest('.team-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.team-slider').find('.sliderNextButton'),
            mobileFirst: true,
            centerMode: true,
            variableWidth: true,
            autoplay: autoplayOn,
            autoplaySpeed: autoplaySpeed,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        centerMode: false,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 4,
                        centerMode: false,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                        centerMode: false,
                        variableWidth: false

                    }
                }
                ,
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 6,
                        centerMode: false,
                        variableWidth: false

                    }
                }
            ]
        });
    })
});


function scrollTo() {
    $('#teamSliderButton').click(function () {
        var target = $('#teamSlider');
        
        $('html, body').stop().animate({
            scrollTop: $($(this).attr('href')).offset().top - 160
        }, 1000);
        return false;
    });
}
scrollTo();

$(function () {
    $(".testimonials-slider .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            fade: true,
            draggable: true,
            prevArrow: thisElement.closest('.testimonials-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.testimonials-slider').find('.sliderNextButton'),
            mobileFirst: true,
        });
    })
});

$(function () {
    $(".news-slider .slider-items").each(function () {
        var thisElement = $(this);

        thisElement.slick({
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            prevArrow: thisElement.closest('.news-slider').find('.sliderPrevButton'),
            nextArrow: thisElement.closest('.news-slider').find('.sliderNextButton'),
            mobileFirst: true,
            centerMode: false,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: "unslick"
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        variableWidth: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        variableWidth: false
                    }
                }  
            ]
        });
    })
});